// RBAC-SUBMIT-01 · Stage B · Submit for Authorisation visibility = exact backend submit permission.
import { hasPerm } from "@/lib/auth";
import { getUser } from "@/lib/secureStorage";

export const SUBMIT_PERMS = {
  PO: "purchase_orders:submit", SO: "sales_orders:submit", ESO: "exports:submit", WO: "production_orders:submit",
  GST: "gst_invoices:submit", ECI: "exports_invoices:submit", EGST: "export_gst_invoices:submit",
  PI: "proforma_invoices:submit", EPI: "export_proforma_invoices:submit", QA: "quality:submit",
};

// RBAC-SUBMIT-01 · Owner rule (mirrors backend `require_submit`): effective Submit =
// Administrator OR <module>:submit OR <module>:create. Edit / approve never imply submit.
export const submitKeys = (key) => [key, `${key.split(":")[0]}:create`];
export const canSubmitDoc = (doc, user = getUser(), permFn = (p) => hasPerm(null, p)) =>
  user?.role === "Administrator" || (!!SUBMIT_PERMS[doc] && submitKeys(SUBMIT_PERMS[doc]).some((k) => !!permFn(k)));
